import {getGroupProduct} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as P from 'ApplicationEntry/ducks/ProductsRiders/pinCare';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';

function* getGroupPinCareProducts() {
  yield takeLatest(P.PinCareActionType.GET_GROUP_PIN_CARE_PRODUCTS, function*(
    action: ReturnType<typeof P.getGroupPinCareProducts>
  ) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;
    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);

    if (E.isRight(response)) {
      yield put(P.changeGroupPinCareProducts(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(P.changeGroupPinCareProducts(response.left));
    }
  });
}

export default function*() {
  yield all([getGroupPinCareProducts()]);
}
